import React, { useEffect, useContext, useState } from "react";
import ProgressPopupData from "../../components/_clients/LargePopup/progressPopupData";
import MealplanPopupData from "../../components/_clients/LargePopup/mealplanPopupData";
import WorkoutPopupData from "../../components/_clients/LargePopup/WorkoutPopup/workoutPopupData";
import PhasePopupData from "../../components/_clients/LargePopup/PhasePopupData/";
import ClientsList from "../../components/_clients/ClientsList";
import ClientProfile from "../../components/_clients/ClientProfile";
import UserContext from "../../services/context/userContext";
import { getClients, getDailyMeasurementProgress, getCLientById, getAllMealplansForUser, getAllProgressForUser, getWorkoutsForUser, getCoachesCalendarItemsDates, getCoachesClientsItem, getCoachesTaskItem } from "../../services/firebase/firestore/getData";
import Workout from "../../components/_clients/Workout";
//import Workouts from "../../components/_clients/Workouts";
import Chat from "../../components/_clients/Chat";
import Overview from "../../components/_clients/Overview";
import Calendar from "../../components/_clients/Calendar";
import CalendarItem from "../../components/_default/Calendar";
import Mealplan from "../../components/_clients/Form";
import Programsplan from "../../components/_clients/Programs";
import TodoList from "../../components/_clients/Calendar/TodoList";
import AddButton from "../../components/_default/AddButton";
import { useCookies } from "react-cookie";
import "./Clients.scss";
import Phase from "../../components/_phase";
import DropDown from "../../components/_default/DropDown";
import Loading from "../../components/_default/Loading";
import logo from '../../assets/images/logo.svg';
import Inviter from "../../components/_clients/Inviter";
import ExerciseHistory from "../../components/_clients/ExerciseHistory";
import SetLogingPopup from "../../components/_clients/LargePopup/SetLogingPopup";
import ActiveClients from "../../components/_clients/ActiveClients";
import PendingClients from "../../components/_clients/PendingClients";


function Clients({ ...props }) {
  const [cookies, setCookie] = useCookies(["clients_active_page"]);
  const [editMode, setEditMode] = useState(false);
  const [filterName, setFilterName] = useState(false);
  const [Loging, setLoging] = useState(false)
  const client_pages = [
    { name: "Overview", icon: "person" },
    { name: "Progress", icon: "agenda" },
    { name: "Mealplan", icon: "file-text" },
    { name: "Access", icon: "chat" },
    //{ name: "Workouts", icon: "person" },
    // { name: "Invite", icon: "person" },
    { name: "Program", icon: "chat" },
    { name: "Exercise History", icon: "chat" },
    // { name: "Invite clients", icon: "person" },
    // { name: "Active Clients", icon: "chat" },
    // { name: "Pending Clients", icon: "chat" },
    //{ name: "Phase", icon: "chat" }
  ];
  const [exercise_history_tab, setTab] = useState(false)
  var a = new Date();
  var year = a.getFullYear();
  var month = a.getMonth() + 1;
  var day = a.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  var time = year + "-" + month + "-" + day;
  var currentTime = year + "-" + month + "-" + day;
  var date = day + "/" + month + "/" + year;
  let longMonth = a.toLocaleString('en-us', { month: 'long' });
  const [fullTime, setFullTime] = useState(day + " " + longMonth + " " + year);
  let shortMonth = a.toLocaleString('en-us', { month: 'short' });
  const [shortFullTime, setShortFullTime] = useState(day + " " + shortMonth + " " + year);
  const [Time, setTime] = useState(time);

  function handleCalendarChange(newSelectedDate) {
    var timestamp = new Date(Date.parse(newSelectedDate));
    var year = timestamp.getFullYear();
    var month = timestamp.getMonth() + 1;
    var day = timestamp.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    time = year + "-" + month + "-" + day;
    date = day + "/" + month + "/" + year;
    longMonth = timestamp.toLocaleString('en-us', { month: 'long' });
    let fulltime = longMonth + " " + day + " " + year;
    setFullTime(fulltime)
    shortMonth = timestamp.toLocaleString('en-us', { month: 'short' });
    let shortFulltime = day + " " + shortMonth + " " + year;
    setShortFullTime(shortFulltime);
    setTime(time)
    console.log("time", time)
  }
  let tabIndex = JSON.parse(localStorage.getItem("tabIndex"))
  // console.log("tab index", tabIndex)
  const [clients, setClients] = useState(false);
  const [selected_client, set_selected_clients] = useState(false);
  const [clientPage, setClientPage] = useState(tabIndex ? client_pages[tabIndex] : client_pages[0]);
  const user = useContext(UserContext);
  const [measurements, setMeasurements] = useState(false);
  let url = window.location.href
  let [mealPlanDates, setMealPlanDates] = useState([])
  let [progressDates, setProgressDates] = useState([])
  let [programDates, setProgramDates] = useState([])
  let [coachCalndarItemDates,setCoachCalendarItemDates]=useState([])
  let [mealPlanTab, setMealPlanTab] = useState(false)
  let [progressTab, setProgressTab] = useState(false)
  // console.log("client page client", selected_client)
  useEffect(() => {
    // debugger

    if (clientPage.name === "Progress") {
      getAllProgressForUser(props.match.params.id, res => {
        // console.log("response from getmealplan user", res)
        if(res){
          res.map((data) => {
            let myDate = data.date
            myDate = myDate.split("-");
            var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
            // console.log("date prop", newDate);
            progressDates.push(newDate.getTime())
            setProgressDates([...progressDates])
          })
        }else{
          console.log("not any progress exists")
        }
        
        console.log("progres dates", progressDates)
      })
    }
    else if (clientPage.name === "Mealplan") {
      getAllMealplansForUser(props.match.params.id, res => {
        // debugger
        // console.log("response from getmealplan user", res)
        if(res){
          res.map((data) => {
            let myDate = data.date
            myDate = myDate.split("-");
            var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
            // console.log("date prop", newDate);
            mealPlanDates.push(newDate.getTime())
            setMealPlanDates([...mealPlanDates])
          })
        }else{
          console.log("not any mealplan exists")
        }
        
        // console.log("meal plan dates", mealPlanDates)

      })
    }
    else if (clientPage.name == "Program") {
      getWorkoutsForUser(props.match.params.id, res => {
        // console.log("workout programs dates", res)
        if(res){
          res.map((data) => {
            let myDate = data.date
            myDate = myDate.split("-");
            var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
            // console.log("date prop", newDate);
            programDates.push(newDate.getTime())
            setProgramDates([...programDates])
          })   
        }else{
          console.log("Not any program exists",res)
        }
       
        // console.log("wrokouts dates array", programDates)
      })
    }
    else{
      getCoachesCalendarItemsDates(user.id, res => {
        // console.log("get coach calendaritems dates", res)
     
        if(res){
          res.map((data) => {
          
            console.log("Datessss",data)
            // let myDate = data.id;
            let myDate = data.date
             
            getCoachesTaskItem(user.id,myDate,res=>{
              // debugger
              if(res.length>0){
                myDate = myDate.split("-");
            var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
            // console.log("date prop", newDate);
            console.log("item exists",newDate.getTime());
            coachCalndarItemDates.push(newDate.getTime())
            // setMealPlanDates(mealPlanDates)
            setCoachCalendarItemDates(coachCalndarItemDates)
              }
            })
            getCoachesClientsItem(user.id,myDate,res=>{
              // debugger
              if(res.length>0){
                myDate = myDate.split("-");
            var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
            // console.log("date prop", newDate);
            console.log("item exists",newDate.getTime());
            coachCalndarItemDates.push(newDate.getTime())
            setCoachCalendarItemDates(coachCalndarItemDates)
              }
            })
           
          });
        }else{
          console.log("not any coachcalendar item exists")
        }
        
        // console.log("coach calendar item dates", coachCalndarItemDates)
    })
    }
    

  }, [clientPage.name])
  useEffect(() => {
    if (props.location.state?.clientPage) {
      setClientPage({ name: props.location.state.clientPage })
    }
  }, [props.location.state]);

  useEffect(() => {
    localStorage.removeItem("tabIndex")
    getDailyMeasurementProgress(props.match.params.id, Time, currentTime, (result) => {
      if (result) {
        setMeasurements(result);
      } else {
        getCLientById(props.match.params.id, (result) => {
          setMeasurements(result.measurements);
        })
      }
    });
  }, [user, props.match.params.id, Time, Loging]);

  useEffect(() => {
    setLoging(false)
    setEditMode(false);
  }, [props.match.params.id, Loging])

  useEffect(() => {
    setLoging(!Loging)
    getClients(user.id, (result) => {
      if (result) {
        setClients(result);
        if (props.match.params.id) {
          result.forEach(element => {
            if (element.date_of_birth) {
              element.date_of_birth = `${element?.date_of_birth?.toDate().getDate()}/${element?.date_of_birth?.toDate().getMonth() + 1}/${element?.date_of_birth?.toDate().getFullYear()}`;
            } else { element.date_of_birth = "not set" };
          });

          console.log(result.find((e) => e.id === props.match.params.id));
          set_selected_clients(result.find((e) => e.id === props.match.params.id));
        } else {
          if (result[0].date_of_birth) {
            result[0].date_of_birth = `${result[0]?.date_of_birth?.toDate().getDate()}/${result[0]?.date_of_birth?.toDate().getMonth() + 1}/${result[0]?.date_of_birth?.toDate().getFullYear()}`;
          } else { result[0].date_of_birth = "not set" }
          set_selected_clients(result[0]);
          props.history.replace("/clients/" + result[0].id);
        }
      } else {
        setClients([]);
      }
    });
  }, [props.match.params]);

  // useEffect(() => {
  //   setCookie("clients_active_page", clientPage, { path: "/" });
  // }, [clientPage]);

  useEffect(() => {
    setTime(time)
  }, [time])

  function selectClient(client) {
    set_selected_clients(client);
    props.history.replace("/clients/" + client.id);
  }

  return (
    <div className="c-page-wrapper">
      <div className="c-page-client">
        <div className="c-page-main --clients">
          {selected_client && (
            <>
              <div className="c-header">
                <div className="c-header-container">
                  {/*<div className="c-profile-data">
                      <div className="c-profile-list-image" style={{ backgroundImage: `url('${selected_client.image}')` }}></div>
                      <div className="c-profile-data-wrapper">
                      </div>
                    </div>*/}
                  <div className="c-header-nav">
                    {!selected_client.image ? (
                      <p>{selected_client.first_name[0] + selected_client.last_name.match(/\b(\w)/g).join("")}</p>
                    ) : (
                      <div className="c-clients-list-image" style={{ backgroundImage: `url('${selected_client.image}')` }}></div>
                    )}
                    <h1 className="c-header-title" style={{display:"flex",flexDirection:"column"}}>{selected_client.first_name} {selected_client.last_name}<span style={{color: "#dbdbdb",fontWeight:"normal",fontSize:"14px",textDecoration:"underline",cursor:"pointer"}} onClick={() => {window.history.back();}}>back</span></h1>
                    <ul className="c-header-nav-wrapper">
                      {client_pages.map((item, idx) => (
                        <li key={idx} className={clientPage.name === item.name ? "c-side-client-menu-header --active" : "c-side-client-menu-header"} onClick={() => { setClientPage(item); setEditMode(false); }}>
                          <p className="c-clients-nav-link">{item.name}</p>
                          
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="c-header-add">
                    {clientPage.name != "Overview" && clientPage.name != "Access" && clientPage.name != "Invite clients" && clientPage.name != "Workout" && clientPage.name !== "Exercise History" && clientPage.name !== "Active Clients" && clientPage.name !== "Pending Clients" && clientPage.name !== "Program" ? <AddButton icon="edit" className="c-clients-button" text={clientPage.name === "Program" ? "Set logging" : "Edit " + clientPage.name} color="#000" backgroundColor="#FFC415" onClick={() => setEditMode(true)} /> : ""}
                  </div>
                  <div className="c-header-logo">
                    <img src={logo} alt="Logo" />
                  </div>
                </div>
              </div>
              <div className="c-page-main-block" style={{ display: 'flex', justifyContent: 'space-between' }}>

                {(() => {
                  switch (clientPage.name) {
                    case "Overview":
                      return <>
                        <div className="c-client-wrapper">
                          <Overview client_id={props.match.params.id} clientList={clients} currentTime={currentTime} timestamp={a} selected_client={selected_client} />
                          <div className={clientPage.name != "Overview" ? "c-side-client-menu-calendar-active" : "c-side-client-menu-calendar"}>
                            <CalendarItem time={coachCalndarItemDates} onCalendarChange={handleCalendarChange} />
                            <TodoList Time={Time} fulltime={fullTime} shortFulltime={shortFullTime} />
                          </div>
                        </div>

                        {props.match.params.id && <Chat isChatOverview={true} client_id={props.match.params.id} />}
                      </>;
                    case "Progress":
                      if (editMode) {
                        return <ProgressPopupData button="Save" savePopup={true} onCancel={() => { setEditMode(false) }} client_id={props.match.params.id} time={Time} currentTime={currentTime} updateData={measurements} />;
                      } else {
                        return <Calendar selected_client={selected_client} client_id={props.match.params.id} time={Time} currentTime={currentTime} />;
                      }
                    case "Mealplan":
                      if (editMode) {
                        return <MealplanPopupData selected_client={selected_client} button="Save" savePopup={true} onCancel={() => { setEditMode(false) }} client_id={props.match.params.id} time={Time} filterName={filterName} />
                      } else {
                        return <Mealplan client_id={props.match.params.id} time={Time} />;
                      }
                    case "Access":
                      return <Programsplan client_id={props.match.params.id} time={Time} />;
                    case "Workout":
                      if (editMode) {
                        return <WorkoutPopupData button="save" savePopup={true} onCancel={() => { setEditMode(false) }} client_id={props.match.params.id} time={Time} filterName={filterName} />
                      } else {
                        return <Workout client_id={props.match.params.id} time={Time} />;
                      }
                    case "Phase":
                      if (editMode) {
                        return <PhasePopupData button="save" savePopup={true} onCancel={() => { setEditMode(false) }} client_id={props.match.params.id} time={Time} filterName={filterName} />
                      } else {
                        return <Phase client_id={props.match.params.id} time={Time} />;
                      }
                    // case "Invite clients":
                    //   return <><Inviter /></>;
                    case "Exercise History":
                      if (editMode) {
                        return <SetLogingPopup exercise_history_tab={exercise_history_tab} set_exercise_history_tab={setTab} />
                      } else {

                        return <><ExerciseHistory exercise_history_tab={exercise_history_tab} set_exercise_history_tab={setTab} /></>
                      }
                    // case "Active Clients":
                    //   return <><ActiveClients /></>
                    // case "Pending Clients":

                    //   return <><PendingClients /></>
                    case "Program":
                      if (editMode) {
                        return <><SetLogingPopup editMode={true} /></>
                      } else {
                        return <>
                          <div className="c-client-wrapper" style={{ display: "flex" }}>
                            {/* <Overview client_id={props.match.params.id} clientList={clients} currentTime={currentTime} timestamp={a} selected_client={selected_client} /> */}
                            <Workout client_id={props.match.params.id} time={Time} />
                            <div style={{ marginTop: "29px" }}>

                              <CalendarItem time={programDates} onCalendarChange={handleCalendarChange} />
                            </div>

                          </div>
                        </>
                      }

                  }
                })()}
                <div style={{ flexDirection: 'row', alignItems: 'flex-start', height: '100%', margin: '30px 30px 30px 0px', borderRadius: 12, backgroundColor: '#FFF', paddingTop: 10, paddingBottom: 10 }}>
                  {
                    (clientPage.name == 'Mealplan' || clientPage.name == 'Progress' || clientPage.name == 'Workout') && <CalendarItem time={clientPage.name=="Progress"?progressDates:clientPage.name=="Mealplan"?mealPlanDates:clientPage.name=="Program"?programDates:["ok"]} onCalendarChange={handleCalendarChange} />
                  }
                </div>
              </div>
            </>
          )}
          {!clients && (<Loading />)}
          {!clients.length && (<div style={{ display: 'flex', textAlign: 'center', width: '100%', justifyContent: 'center', paddingTop: 100 }}>No clients, create new client in Aurum app</div>)}
        </div>
      </div>
    </div>
  );
}

export default Clients;